import { useEffect, useState } from 'react';
import { api } from './api';
import { LogStream } from './LogStream';
import { Select } from './Select';
import type { LogDevice, Notify } from './types';

/** 全局实时日志页：跨设备查看，设备筛选与设备详情里的日志共用同一套流。 */
export function LoggerPage({ notify }: { notify: Notify }) {
  const [devices, setDevices] = useState<LogDevice[]>([]);
  const [deviceId, setDeviceId] = useState('');

  useEffect(() => {
    let disposed = false;
    void api<{ devices: LogDevice[] }>('/api/logger/devices')
      .then((data) => { if (!disposed) setDevices(data.devices); })
      .catch((cause) => { if (!disposed) notify('error', cause instanceof Error ? cause.message : '读取设备列表失败'); });
    return () => { disposed = true; };
  }, [notify]);

  return (
    <div className="log-page">
      <LogStream
        apiBase="/api/logger"
        global
        deviceId={deviceId}
        showDevice
        notify={notify}
        leading={
          <label className="log-filter">设备
            <Select aria-label="日志设备" value={deviceId} onChange={(event) => setDeviceId(event.target.value)}>
              <option value="">全部设备</option>
              {devices.map((device) => (
                <option key={device.id} value={device.id}>
                  {device.name}{device.fqdn ? ` · ${device.fqdn}` : ''}
                </option>
              ))}
            </Select>
          </label>
        }
      />
    </div>
  );
}
